export default class Instruction {

    constructor() {
        this.instructionStatus = '';
        this.isMandatory = '';
        this.instructionType = '';
        this.sequenceNo = '';
    }
}



// WEBPACK FOOTER //
// ./src/models/instruction.js